"use client";

// ── DeeperInsightsCTA ──────────────────────────────────────────────────────────

interface DeeperInsightsCTAProps {
  detailedLoading: boolean;
  detailedError: string | null;
  onGetDetailed: () => void;
}

export function DeeperInsightsCTA({
  detailedLoading,
  detailedError,
  onGetDetailed,
}: DeeperInsightsCTAProps) {
  return (
    <div className="card-sacred p-6 sm:p-8 text-center bg-gradient-to-br from-ish-accent-light to-white border-2 border-ish-accent">
      <div className="mb-3">
        <svg
          width="36"
          height="36"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          className="mx-auto text-ish-accent"
        >
          <path d="M9 12h6M12 9v6M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h3 className="text-[18px] font-bold mb-2 text-ish-dark font-serif">Want Deeper Insights?</h3>
      <p className="text-[14px] leading-relaxed mb-5 max-w-md mx-auto text-ish-text-muted">
        Get Navamsha (D9) chart analysis, Dasha compatibility for the next 5 years, Dosha
        cross-check, and personalized remedy recommendations.
      </p>

      {detailedError && (
        <div className="mb-4 text-[13px] rounded-lg p-3 text-center text-error bg-error/5 border border-error/20">
          {detailedError}
        </div>
      )}

      <button
        onClick={onGetDetailed}
        disabled={detailedLoading}
        className="btn-sacred font-semibold py-3 px-8 rounded-lg text-[14px] disabled:opacity-50"
      >
        {detailedLoading ? (
          <span className="flex items-center gap-2 justify-center">
            <span className="w-4 h-4 border-2 border-t-transparent rounded-full animate-spin border-ish-cream" />
            Analyzing Charts...
          </span>
        ) : (
          "Get Detailed Report"
        )}
      </button>

      <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-ish-text-faint">
        <span>Navamsha Analysis</span>
        <span>Dasha Compatibility</span>
        <span>Dosha Cross-Check</span>
        <span>Remedy Recommendations</span>
      </div>
    </div>
  );
}
